module.exports = __webpack_public_path__ + "img/3.affcaa4c.jpg";